<div class="instructor-slides">
    <owl-carousel-o [options]="instructorSlides">


        <ng-template carouselSlide *ngFor="let doctor of doctors">
            <div *ngIf="doctor.photo.path !== 'b3db70e5-d4bb-44cd-a89a-54d77dbcebbb'" class="single-instructor-box mb-30">
                <div class="image">
                    <div *ngIf="doctor.photo"><img [src]="setFilePath(doctor)" alt="test"></div>
<!--                    <div *ngIf="!doctor.photo"><img src="../../../assets/img/medici/no-image.jpg" alt="image"></div>-->
<!--                    <img src="assets/img/instructor/instructor1.jpg" alt="image">-->
                    <ul class="social">
                        <li><a href="/echipa/medic/{{doctor.id}}" target="_blank"><i class="bx bxl-search"></i></a></li>
                    </ul>
                </div>
                <div class="content">
                    <h3><a routerLink="/echipa/medic/{{doctor.id}}">Dr. {{doctor.name}}</a></h3>
                    <span>Medic - grad + specialitate</span>
                </div>
            </div>
        </ng-template>


<!--        <ng-template carouselSlide>
            <div class="single-instructor-box mb-30">
                <div class="image">
                    <img src="assets/img/instructor/instructor2.jpg" alt="image">
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class="bx bxl-search"></i></a></li>
                    </ul>
                </div>
                <div class="content">
                    <h3><a routerLink="/single-instructor">Dr. Agapie-Florea Cornelia-Monica</a></h3>
                    <span>Medic primar dermato-venerolog </span>
                </div>
            </div>
        </ng-template>
        <ng-template carouselSlide>
            <div class="single-instructor-box mb-30">
                <div class="image">
                    <img src="assets/img/instructor/instructor3.jpg" alt="image">
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class="bx bxl-search"></i></a></li>
                    </ul>
                </div>
                <div class="content">
                    <h3><a routerLink="/single-instructor">Dr. Zamfir Constantin Cristian</a></h3>
                    <span>Medic primar chirugie generala</span>
                </div>
            </div>
        </ng-template>
        <ng-template carouselSlide>
            <div class="single-instructor-box mb-30">
                <div class="image">
                    <img src="assets/img/instructor/instructor4.jpg" alt="image">
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class="bx bxl-search"></i></a></li>
                    </ul>
                </div>
                <div class="content">
                    <h3><a routerLink="/single-instructor">Dr. Ispas Gabriela</a></h3>
                    <span>Medic primar boli interne </span>
                </div>
            </div>
        </ng-template>-->


    </owl-carousel-o>
</div>
